import { render } from "./DetalleInspeccionComponent.vue?vue&type=template&id=f8b9b27a"
import script from "./DetalleInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./DetalleInspeccionComponent.vue?vue&type=script&lang=js"

import "./DetalleInspeccionComponent.vue?vue&type=style&index=0&id=f8b9b27a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__